module.exports = __webpack_public_path__ + "img/6.d81a15e3.jpg";